import { RRRPhoneNumber } from "./elements/phone-number";

type FormFieldElement = HTMLInputElement | HTMLSelectElement;

export default function toggleInternationalAddress(el: HTMLElement) {
  const internationalAddressCheckbox = el.querySelector<HTMLInputElement>(
    "[data-international-address-checkbox]"
  );

  const internationalEnabledFields = el.querySelectorAll<FormFieldElement>("[data-enable-international]");
  const auEnabledFields = el.querySelectorAll<FormFieldElement>("[data-enable-au]");
  const stateSelectBlock = el.querySelector<HTMLElement>(".form-card__state")!;
  const phoneNumberFields = el.querySelectorAll<RRRPhoneNumber>("rrr-phone-number")
  const countrySelectBlock = el.querySelector<HTMLElement>(".form-card__country")!;
  const countrySelectInput = countrySelectBlock.querySelector<HTMLSelectElement>("select");

  internationalAddressCheckbox?.addEventListener("change", toggleStateSelect);
  countrySelectInput?.addEventListener("change", toggleStateSelect);
  toggleStateSelect();

  function isInternationalAddress() {
    if (internationalAddressCheckbox) {
      return internationalAddressCheckbox.checked;
    }

    if (countrySelectBlock) {
      return countrySelectInput?.value !== "AU";
    }

    return true;
  }

  function toggleStateSelect() {
    const intl = isInternationalAddress();

    stateSelectBlock.classList.toggle("form-card__state--select-toggle", intl);

    // only hide country dropdown if this is a kind of form with
    // an international select checkbox
    if (internationalAddressCheckbox) {
      countrySelectBlock.classList.toggle("form-card__country--hidden", !intl);
    }

    // Set fields to disabled as appropriate
    for (const field of internationalEnabledFields) {
      field.disabled = !intl;
    }
    for (const field of auEnabledFields) {
      field.disabled = intl;
    }

    // Update country of phone number fields
    for (const field of phoneNumberFields) {
      if (intl) {
        field.removeAttribute("australian");
      } else {
        field.setAttribute("australian", "");
      }
    }
  }
}
